import { useQuery } from '@tanstack/react-query';
import { channelsApi } from '../services';

/**
 * Hook to fetch widget configuration for a channel
 *
 * @example
 * const { data, isLoading } = useWidgetConfig(channelId);
 */
export const useWidgetConfig = (channelId: string | undefined) => {
  return useQuery({
    queryKey: ['widget-config', channelId],
    queryFn: () => channelsApi.getWidgetConfig(channelId!),
    enabled: !!channelId,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
};
